abstract class TabGroup extends Widget {
    firstChild: string;

    protected constructor(identifier: string, container: JQuery, controller: Controller, widgetFactory: WidgetFactory, mode: string) {
        super(identifier, Action.NONE, controller, container, mode);
        this.initHTML(container, widgetFactory);
    }

    abstract initHTML(container: JQuery, widgetFactory: WidgetFactory);

    newState() {
        return new TabGroupState();
    }

    selectFirstTab() {
        var state = this.getState();

        state.selectTab(this.firstChild);

        this.setState(state);
    }

    setState(newTabGroupState: TabGroupState) {
        this.setChildrenStates(newTabGroupState);
    }

    getState() {
        let result = new TabGroupState();

        result.childrenStates = this.getChildrenStates();

        return result;
    }

    previewState(newTabGroupState, timeRatioLeft) {
        this.previewChildrenStates(newTabGroupState, timeRatioLeft);
    }

    removePreviewState() {
        this.removePreviewChildrenStates();
    }

    abstract getTabHeaderContainer();
    abstract getTabContentContainer();
}
